var React = require('react');

function SearchLuckyNumber (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"b"},React.createElement("rect",{"width":"32","height":"32"}))),React.createElement("g",{"id":"a","clipPath":"url(#b)","key":1},React.createElement("path",{"d":"M8.122,18.346a7.234,7.234,0,0,0,9.645.539l2.87,2.878a.807.807,0,1,0,1.141-1.141l-2.918-2.878a7.114,7.114,0,0,0,1.608-4.509A7.234,7.234,0,1,0,8.122,18.346ZM9.255,9.255a5.655,5.655,0,0,1,8,8h0A5.627,5.627,0,1,1,9.3,9.3Z","transform":"translate(2 2)","fill":"#2425aa"}))]);
}

SearchLuckyNumber.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = SearchLuckyNumber;

SearchLuckyNumber.default = SearchLuckyNumber;
